import script from "./SortingButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortingButton.vue?vue&type=script&setup=true&lang=ts"

import "./SortingButton.vue?vue&type=style&index=0&id=ba4c9a36&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba4c9a36"]])

export default __exports__